import { Check } from "lucide-react";
import { Reveal, Kicker } from "../lib/motion";

const CREDENTIALS = [
  "FCA — Fellow Chartered Accountant, India",
  "US CPA",
  "Approximately 30 years of finance leadership experience",
  "Senior leadership experience up to SVP Finance",
  "Former SVP Finance at a ~$125M ARR technology company",
  "Experience across SaaS, FinTech, HealthTech and IT Services",
  "Deep hands-on exposure to modern finance technology and systems",
  "Experience working across India and international operations",
];

export const About = () => (
  <section id="about" data-testid="about-section" className="bg-white py-24 md:py-32">
    <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-[0.8fr_1.2fr] gap-14 lg:gap-20 items-center">
      <Reveal className="relative order-last lg:order-first">
        <div aria-hidden="true" className="absolute -inset-5 -z-10 rounded-[2rem] bg-mist border border-border -rotate-2" />
        <figure className="relative overflow-hidden rounded-[1.6rem] shadow-[0_24px_60px_rgba(10,31,60,0.18)]">
          <img
            src="/assets/ramesh.webp"
            alt="Ramesh Nanduri — Founder and Managing Partner of Cogniti.ai CFO, LLP"
            className="h-[460px] w-full object-cover object-top"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-[linear-gradient(to_top,rgba(10,31,60,0.45),transparent_40%)]" />
          <figcaption className="absolute bottom-5 left-6">
            <p className="font-display text-lg font-bold text-white">Ramesh Nanduri</p>
            <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-white/70">Founder & Managing Partner</p>
          </figcaption>
        </figure>
      </Reveal>

      <div>
        <Reveal>
          <Kicker>About the Founder</Kicker>
          <h2 className="mt-6 font-display text-4xl md:text-5xl font-bold tracking-tight text-navy">
            Leader. CFO. <span className="font-editorial italic font-medium text-brand-hover">Partner.</span>
          </h2>
          <p className="mt-6 text-base md:text-lg leading-relaxed text-body">
            Cogniti.ai CFO is led by <strong className="text-navy">Ramesh Nanduri, FCA, US CPA</strong>,
            a senior finance professional with approximately three decades of
            experience in technology-sector finance — from controllership and
            compliance to investor reporting, treasury and finance transformation
            across India and international operations.
          </p>
        </Reveal>

        <div className="mt-9 grid sm:grid-cols-2 gap-x-8 gap-y-4">
          {CREDENTIALS.map((c, i) => (
            <Reveal key={c} delay={i * 0.06} y={20}>
              <div className="flex items-start gap-3">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand/15">
                  <Check size={11} strokeWidth={3.5} className="text-brand-hover" />
                </span>
                <p className="text-sm font-semibold leading-snug text-navy/85">{c}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
